<template>
  <div class="header">
    <i class="iconfont iconmenu menuIcon" @click="menuChange(menuOpen)"></i>
    <div class="headFunc">
      <div class="portrait"></div>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native='changePassword'>修改密码</el-dropdown-item>
          <el-dropdown-item @click.native='outer'>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 修改密码弹出层 -->
    <el-dialog :visible.sync="changePasswordDialog" :title="changePasswordTitle" width="500px" :modal-append-to-body="false" :close-on-click-modal="false" @close="changePasswordNotBtn">
      <el-form ref="changePasswordForm" :model="changePasswordForm" :rules="changePasswordRules" label-width="100px" size="small">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model.trim="changePasswordForm.newPassword" placeholder="新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="againPassword">
          <el-input v-model.trim="changePasswordForm.againPassword" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="changePasswordNotBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="changePasswordLoading" @click="changePasswordOkBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      userName: this.$store.state.user.userName, // 用户名
      menuOpen: true,
      changePasswordDialog: false, // 修改密码弹出层状态
      changePasswordTitle: '修改密码', // 修改密码弹出层标题
      changePasswordLoading: false, // 修改密码弹出层确定按钮loading
      changePasswordForm: {
        newPassword: '', // 新密码
        againPassword: '' // 确认密码
      },
      changePasswordRules: {
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z_]+$/
              if (!reg.test(value)) {
                callback(new Error('新密码由英文字符、数字及下划线组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        againPassword: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value !== this.changePasswordForm.newPassword) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted () {
    this.$emit('isCollapse', false)
  },
  methods: {
    menuChange (menuOpen) {
      if (menuOpen) {
        this.menuOpen = !this.menuOpen
        this.$emit('isCollapse', true)
      } else {
        this.menuOpen = !this.menuOpen
        this.$emit('isCollapse', false)
      }
    },
    outer () {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          message: '您已退出，请重新登录',
          type: 'warning',
          duration: 1000
        })
        sessionStorage.clear('token')
        sessionStorage.removeItem('menu1')
        sessionStorage.removeItem('menu2')
        sessionStorage.removeItem('activeMenu')
        sessionStorage.removeItem('funcData')
        sessionStorage.removeItem('userId')
        sessionStorage.removeItem('userName')
        sessionStorage.removeItem('villageId')
        sessionStorage.removeItem('villageName')
        sessionStorage.removeItem('villageAddress')
        sessionStorage.removeItem('username')
        sessionStorage.removeItem('password')
        sessionStorage.removeItem('dlevelcode')
        sessionStorage.removeItem('isLogin')
        this.$store.state.menus.isLogin = 0
        this.$store.state.menus.activeMenu = ''
        this.$router.push('login')
      }).catch(() => {})
    },
    changePassword () {
      this.changePasswordDialog = true
    },
    changePasswordNotBtn () {
      this.changePasswordLoading = false
      this.changePasswordForm.newPassword = ''
      this.changePasswordForm.againPassword = ''
      this.$refs.changePasswordForm.resetFields()
      this.changePasswordDialog = false
    },
    changePasswordOkBtn () {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          this.changePasswordLoading = true
          let formData = new FormData()
          formData.append('id', this.$store.state.user.userId)
          formData.append('newPassword', this.changePasswordForm.newPassword)

          this.$http({
            method: 'post',
            url: this.$api.reset_password,
            data: formData
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.$message({
                message: '修改密码成功，请重新登录',
                type: 'success',
                duration: 1000
              })
              this.changePasswordNotBtn()
              sessionStorage.clear('token')
              sessionStorage.removeItem('menu1')
              sessionStorage.removeItem('menu2')
              sessionStorage.removeItem('activeMenu')
              sessionStorage.removeItem('funcData')
              sessionStorage.removeItem('userId')
              sessionStorage.removeItem('userName')
              sessionStorage.removeItem('villageId')
              sessionStorage.removeItem('villageName')
              sessionStorage.removeItem('villageAddress')
              sessionStorage.removeItem('username')
              sessionStorage.removeItem('password')
              sessionStorage.removeItem('dlevelcode')
              sessionStorage.removeItem('isLogin')
              this.$store.state.menus.isLogin = 0
              this.$store.state.menus.activeMenu = ''
              this.$router.push('login')
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
              this.changePasswordLoading = false
            }
          }).catch((err) => {
            console.log(err)
            this.changePasswordLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.header
  box-sizing border-box
  padding 0 20px
  width 100%
  height 100%
  line-height 60px
  background-color #fff
  box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
  text-align center
  .menuIcon
    float left
    margin-top 20px
    line-height 1
    font-size 20px
    color #999
    cursor pointer
  .headFunc
    float right
    height 100%
    .portrait
      float left
      margin-top 14px
      margin-right 8px
      width 32px
      height 32px
      border-radius 50%
      background-image url('./head.png')
      background-repeat no-repeat
      background-size 100% 100%
    .el-dropdown
      display inline
      color #333
      cursor pointer
      .el-icon-arrow-down
        font-size 12px
  &>>>.el-dialog
    .el-dialog__header
      line-height 1
      text-align left
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue